import { attachClient, createApiClient } from '@matix/api-client';

/**
 * The shared api-client for the appointments app. Isolated JWT storage under
 * the `pos:appointments` namespace so tokens don't collide with the other
 * apps on the matix.one parent domain. The session token is injected as a
 * Bearer header on every request; a 401 clears it and fires onUnauthorized.
 */
let onUnauthorizedHandler: () => void = () => {};
export function setOnUnauthorized(fn: () => void): void {
  onUnauthorizedHandler = fn;
}

const client = createApiClient({
  storageNamespace: 'pos:appointments',
  onUnauthorized: () => onUnauthorizedHandler(),
});
attachClient(client);

export { client };
